import paymentTypes from '../config/paymentTypes';

const getPaymentMethodInfo = (type) => {
  return paymentTypes[type]?.active ? paymentTypes[type] : {};
};

export default getPaymentMethodInfo;
